import { render, staticRenderFns } from "./item-contact.vue?vue&type=template&id=64f01aae"
import script from "./item-contact.vue?vue&type=script&lang=js"
export * from "./item-contact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports